const groupPropertyPrices = (property_prices, groupFieldName='UnitType') => {
// Regroup by groupFieldName
const groupKeys = [
  ...new Set(property_prices.map(item => item[groupFieldName]))
];
const formatPrice = (priceArray, op) => {
  const priceNumeric = priceArray.filter(item => item > 0);
  const priceAsk     = priceArray.filter(item => item === null);
  const priceSoldOut = priceArray.filter(item => item === "SOLD OUT");
  return priceNumeric.length > 0 ? op(...priceNumeric) : (priceAsk.length > 0 ? null : "SOLD OUT");
}
return groupKeys.sort()
  .filter(item => item)
  .map(key => {
    const priceItems    = property_prices.filter(item => item[groupFieldName] === key);
    const minPrice      = priceItems.map(item => item["MinPrice"]);
    const maxPrice      = priceItems.map(item => item["MaxPrice"]);
    const minPricePsf   = priceItems.map(item => item["MinPricePsf"]);
    const maxPricePsf   = priceItems.map(item => item["MaxPricePsf"]);
    const minArea       = priceItems.map(item => item["MinArea"]).filter(item => item > 0);
    const maxArea       = priceItems.map(item => item["MaxArea"]).filter(item => item > 0);
    const noOfUnits     = priceItems.map(item => item["NoOfUnits"]);
    const noOfUnitsSold = priceItems.map(item => item["NoOfUnitsSold"]);
    return {
      key: key,
      [groupFieldName]: key,
      Bedrooms: priceItems[0].Bedrooms,
      MinPrice: formatPrice(minPrice, Math.min),
      MaxPrice: formatPrice(maxPrice, Math.max),
      MinPricePsf: formatPrice(minPricePsf, Math.min),
      MaxPricePsf: formatPrice(maxPricePsf, Math.max),
      MinArea: minArea.length > 0 ? Math.min(...minArea) : null,
      MaxArea: maxArea.length > 0 ? Math.max(...maxArea) : null,
      Data: priceItems,
      NoOfUnits: noOfUnits.reduce((a,b) => a+b, 0),
      NoOfUnitsSold: noOfUnitsSold.reduce((a,b) => a+b, 0),
    }
  })
}

const getSearchParams = ({ search_type }) => {

  return {
    // availability: 11, // Double check
    per_page: search_type === "map" ? 300 : 12,
    fields: [
      "id",
      "sync_id",
      "featured_media",
      "featured_media_url",
      "featured_media_url__medium_large",
      "featured_media_url__thumbnail",
      "title",
      "link",
      "availability",
      "feature",
      "coordinates",
      "expected_top_year",
      "project_name",
      "property_type",
      "tenure",
      "location",
      "total_units",
      "studio_price",
      "1br_price",
      "2br_price",
      "3br_price",
      "4br_price",
      "5br_price",
      "6br_price",
      "penthouse_price",
      "ribbon_text",
    ],
    order: {
      orderby_custom: [
        "launch_date",
        "launch_date",
        "post_date",
      ],
      orderby_isnull_custom: [
        "1",
        "0",
        "0",
      ],
      order_custom: [
        "DESC",
        "DESC",
        "DESC",
      ],
      ordertype_custom: [
        "DATE",
        "DATE",
        "DATE",
      ]
    }
  }

}

const getSearchParamsHook = () => {

  const searchParamsHook = (params) => {

    let newParams = { ...params };
    if (params.project_name) {
      newParams["project_name[compare=LIKE]"] = params.project_name;
      delete newParams.project_name;
    }
    if (params.location) {
      // Passthrough
    }
    if (params.tenure) {
      // Passthrough
    }
    if (params.property_type) {
      const property_type = Array.isArray(params.property_type) ? params.property_type : [params.property_type];
      newParams["property_type[compare=REGEXP]"] = property_type.join("|");
      delete newParams.property_type;
    }
    if (params.completion_date) {
      let completion_date = Array.isArray(params.completion_date) ? params.completion_date : [params.completion_date];
      if (completion_date.includes("Completed")) {
        const startYear = 1995;
        const currentYear = new Date().getFullYear();
        completion_date = completion_date.concat(
          [...Array(currentYear-startYear+1).keys()].map(item => item+startYear)
        );
      }
      newParams["completion_date[compare=REGEXP]"] = completion_date.join("|");
      delete newParams.completion_date;
    }
    if (params.bedroom) {
      const bedroom = Array.isArray(params.bedroom) ? params.bedroom : [params.bedroom];
      let orObject = {};
      for (const item of bedroom) {
        const field = (item === 0 ? "studio" : item.toString().toLowerCase() + (item > 0 ? "br" : "") + "_price");
        orObject[field+"[compare=>=][type=NUMERIC]"] = "0";
      }
      newParams["bedroom_query"] = { or: orObject };
      delete newParams.bedroom;
    }
    if (params.price_min > 0 || params.price_max >  0) {
      if (isNaN(params.price_min)) {
        params.price_min = 1; // << Do not set to 0
      }
      if (isNaN(params.price_max)) {
        params.price_max = 50*1e6;
      }
      const priceFields = ["studio_price", "1br_price", "2br_price", "3br_price", "4br_price", "5br_price", "penthouse_price"];
      const bedroom = priceFields.filter(item => {
        const selectedBedroom = params.bedroom || [0,1,2,3,4,5,"Penthouse"];
        const filterList = selectedBedroom.map(item => {
          const field = (item === 0 ? "studio" : item.toString().toLowerCase() + (item > 0 ? "br" : "") + "_price");
          return field;
        })
        return filterList.includes(item);
      });
      let orObject = {};
      for (const item of bedroom) {
        const field = item;
        orObject[field+"[compare=BETWEEN][type=NUMERIC]"] = [params.price_min.toString(), params.price_max.toString()];
      }
      newParams["price_query"] = { or: orObject };
      delete newParams.price_min;
      delete newParams.price_max;
    }

    return newParams;
  }

  return searchParamsHook;

}

let remoteRes = [];

const getSearchResultsHook = () => {

  function isLocalHost() {
    const hostname = window.location.hostname;
    return ['localhost', '127.0.0.1', '::1', ''].includes(hostname);
  }

  const searchResultsHook = async (res) => {

    try {
      if (remoteRes.length === 0) {
        // console.log('fetch')
        const response = await fetch("https://me.rocksolid.sg/api/developersales/property", {
          method: "GET",
          referrerPolicy: "strict-origin-when-cross-origin",
        });
        remoteRes = (await response.json())?.results || [];
      }
      else {
        // console.log('cache')
      }
      if (Array.isArray(res?.data)) {
        res.data = res.data.map(item => {
          const remoteItem = remoteRes.find(remoteItem => remoteItem.Path === item.sync_id);
          if (remoteItem) {
            const isResidential = remoteItem?.PriceSummary?.filter(item => item.Bedrooms > 0)?.length || 0;
            item.property_prices = groupPropertyPrices(remoteItem?.PriceSummary, isResidential ? "Bedrooms" : "UnitType");
          }
          return item;
        });
      }
    }
    catch (e) {
      //
    }

    return res;
  }

  return searchResultsHook;

}

export { getSearchParams, getSearchParamsHook, getSearchResultsHook };
